import React, { useState } from "react";
import Navbar from "../../../../Components/Desktop/Navbar/Navbar";
import { Box, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "../../ProductPages/ProductPages.scss";
import RequestDemo from "../../../../Components/Desktop/RequestDemo/RequestDemo";
import Footer from "../../../../Components/Desktop/Footer/Footer";
import CustomButton from "../../../../Components/CustomButton/CustomButton";

function OnlineTransactionJourney() {
  const navbarStyle = { backgroundColor: "#6458D8", color: "#ffffff" };
  const image = "./images/insurevent_logo_white.svg";
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const onlineTransactionFeatureArray = [
    {
      image: "./images/instant_policy_issuance.png",
      heading: "Instant Policy Issuance",
      desc: "Seamlessly receive policies in an instant with our automated processes. Insurvent's technology ensures swift and efficient policy issuance, putting coverage in your customers hands within moments.",
    },
    {
      image: "./images/rt_premium_calculation.png",
      heading: "Real-Time Premium Calculation",
      desc: "Harness the power of real-time data analytics with our advanced algorithms. Our system processes dynamic data sets for precise and up-to-the-minute premium quotes, providing transparency and accuracy.",
    },
    {
      image: "./images/p&c_lifecycle_mgmt.png",
      heading: "Policy & Customer Lifecycle Management",
      desc: "Navigate the complete lifecycle effortlessly. Insurvent's integrates policy and customer data seamlessly, utilizing advanced data management tools for efficient tracking, analysis, and personalized experiences.",
    },
    {
      image: "./images/proposal_journey_mgmt.png",
      heading: "Proposal Journey Optimization",
      desc: "Experience a refined proposal journey with our tech-infused optimization. Our platform streamlines proposal submissions, making the process seamless and efficient for both insurers and customers.",
    },
    {
      image: "./images/ckyc_journry.png",
      heading: "CKYC (Centralized Know Your Customer) Journey",
      desc: "Streamline your policy buying processes with our CKYC journey. Insurvent integrates CKYC functionalities to ensure a thorough and efficient customer verification process, adhering to compliance standards seamlessly.",
    },
  ];

  const whyChooseInsurventArray = [
    {
      image: "./images/wc_icon1.png",
      heading: "Comprehensive Integration",
      desc: "Insurvent excels in integrating a diverse array of third-party insurer services, creating a unified and user-centric insurance journey. From claims processing to policy management, we've got it all covered.",
    },
    {
      image: "./images/wc_icon2.png",
      heading: "User-Friendly Interface",
      desc: "Navigate the complexities of insurance effortlessly with our intuitive and user-friendly interface capabilities. Our online transaction journey is designed to be simple, efficient, and tailored to meet the demands of the modern consumer.",
    },
    {
      image: "./images/wc_icon3.png",
      heading: "Data Security",
      desc: "Trust is paramount, and at Insurvent, we prioritize the security of your information. Our robust security measures ensure that your data is protected throughout the online transaction journey.",
    },
    {
      image: "./images/wc_icon4.png",
      heading: "Innovation at Its Core",
      desc: " Stay ahead of the curve with our innovative approach. Insurvent is committed to driving industry advancements, keeping you at the forefront of digital insurance experiences.",
    },
  ];

  const product_basket = [
    {
      img: "./images/health_ins.svg",
      title: "Health Insurance",
      class: "health",
    },
    {
      img: "./images/car_ins.svg",
      title: "Car Insurance",
      class: "car",
    },
    {
      img: "./images/bike_ins.svg",
      title: "Bike Insurance",
      class: "bike",
    },
    {
      img: "./images/term_ins.svg",
      title: "Term Insurance",
      class: "term",
    },
    {
      img: "./images/investment_ins.svg",
      title: "Investment Plans",
      class: "investment",
    },
    {
      img: "./images/travel_ins.svg",
      title: "Travel Insurance",
      class: "travel",
    },
    {
      img: "./images/home_ins.svg",
      title: "Home Insurance",
      class: "home",
    },
    {
      img: "./images/shopkeeper_ins.svg",
      title: "Shopkeeper Insurance",
      class: "shopkeeper",
    },
    {
      img: "./images/commercial_ins.svg",
      title: "Commercial Vehicle",
      class: "commercial",
    },
  ];

  return (
    <>
      <Navbar
        style={navbarStyle}
        image={image}
        class1="whiteMenu"
        border="border"
      />

      <Box className="productPage_wrapper">
        <Box className="productHeader_section" marginBottom={"80px"}>
          <Grid container spacing={3} className="row">
            <Grid sm={12} md={6} lg={6} alignSelf={"center"}>
              <h1>
                <span>Welcome to Insurvent's Online Transaction Journey </span>–
                Your Passport to a Digitized Insurance Experience!
              </h1>
            </Grid>
            <Grid
              sm={12}
              md={6}
              lg={6}
              textAlign={"end"}
              className="text-md-center"
            >
              <img src="./images/ot_journey_header_img.svg" alt="ot_jouney" />
            </Grid>
          </Grid>
        </Box>

        <Box className="productInfo_wrapper" marginBottom={"60px"}>
          <Grid container spacing={3} className="row">
            <Grid xs={12}>
              <Box className="productInfo_section">
                <Grid container spacing={3} className="row">
                  <Grid xs={6}>
                    <img
                      src={"./images/ot_journey_desc_img.svg"}
                      alt="erp_desc"
                      style={{ maxHeight: "380px" }}
                    />
                  </Grid>
                  <Grid xs={6} alignSelf={"center"}>
                    <h6>
                      Leading <span>OTJs</span>
                    </h6>
                    <p>
                      Insurvent leads the way in digital insurance integration,
                      leveraging advanced technology to create a seamless online
                      transaction journey. Our robust capabilities span across a
                      spectrum of third-party insurer services, delivering a
                      tech-focused solution for the digitized insurance buying
                      experience.
                    </p>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="online_journey" marginBottom={"80px"}>
          <Grid container spacing={3} className="row">
            <Grid xs={12} sm={6} lg={4} marginTop={"100px"}>
              <h5 className="heading">
                What Sets
                <span style={{ display: "inline-block" }}>
                  {" "}
                  Insurvent's Online Transaction
                </span>{" "}
                Journeys Apart?
              </h5>
            </Grid>
            {onlineTransactionFeatureArray.map((item, index) => (
              <Grid xs={12} sm={6} lg={4} marginTop={"100px"}>
                <Box className="iot_box">
                  <img src={item.image} alt="icon" />
                  <h6>{item.heading}</h6>
                  <p>{item.desc}</p>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box marginBottom={"80px"} className="seamless_buying_journeys">
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12}>
              <Box className="product_basket">
                <h5 className="heading mb-4 text-center">
                  Seamless
                  <span> Buying Journeys</span>
                </h5>
                <ul>
                  {product_basket.map((data, index) => (
                    <li>
                      <Box className={`image_Section ${data.class}`}>
                        <img src={data.img} />
                      </Box>
                      <Box className="text_section">
                        <h6>{data.title}</h6>
                      </Box>
                      <Box className="ctaBtn" textAlign={"center"}>
                        <CustomButton
                          text_name={"Inquire"}
                          class_name="blueLgBtn"
                        />
                      </Box>
                    </li>
                  ))}
                </ul>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box marginBottom={"80px"} className="why_choose_insurvent">
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12}>
              <h5 className="heading mb-6 text-center">
                Why
                <span> Choose Insurvent?</span>
              </h5>
            </Grid>
          </Grid>
          <Grid container columnSpacing={3} className="row">
            <Grid xs={6}>
              <img
                src="./images/why_choose.png"
                alt="why_choose"
                style={{ margin: "auto" }}
              />
            </Grid>
            <Grid xs={6}>
              {whyChooseInsurventArray.map((item, index) => (
                <Box
                  className={`wc_box ${index === openIndex ? "open" : ""}`}
                  onMouseEnter={() => setOpenIndex(index)}
                  onMouseLeave={() => setOpenIndex(null)}
                >
                  <span>
                    <img src={item.image} alt="" />
                  </span>
                  <Box className="content_box">
                    <h6>{item.heading}</h6>
                    <p>{item.desc}</p>
                  </Box>
                </Box>
              ))}
            </Grid>
          </Grid>
        </Box>

        <Box marginBottom={"80px"}>
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12}>
              <Box
                sx={{
                  background: "#F3F2FC",
                  borderRadius: "12px",
                  padding: "24px",
                }}
              >
                <p style={{ textAlign: "center" }}>
                  Empower your digital insurance journey with Insurvent's
                  Tech-Driven Online Transaction Journey. From instant policy
                  issuance to real-time premium calculation and advanced
                  lifecycle management, we bring a tech-focused solution to
                  redefine your digital insurance experiences. Welcome to the
                  future of insurance integration – welcome to Insurvent.
                </p>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <RequestDemo
          formHeading={
            <>
              Get In <span> Touch</span>
            </>
          }
          formDesc={
            "Experience the Future: Request a Demo and Witness the Power of Our Solutions in Action!"
          }
          formImg_url={"./images/request_demo_img.png"}
        />
      </Box>

      <Footer />
    </>
  );
}

export default OnlineTransactionJourney;
